import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {replacePill} from 'src/components/criteria-strip';
import {MAX_SELECTED_ACCOUNTS} from 'src/constants';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';


type Props = {
    accountIds: number[],

    showAddToAccountTeam: boolean,
    openAddToAccountTeamTool: () => void,

    showSetAccountStatus: boolean,
    openSetAccountStatusTool: () => void,

    showUpdateLicense: boolean,
    openEnableModuleAccessPermissionsTool: () => void,
    openDisableModuleAccessPermissionsTool: () => void,
};

export const ToolsRow = (props: Props) => {
    const dispatch = useDispatch();
    const {accountIds} = props;

    const onAddToCriteria = useCallback(() => {
        dispatch(replacePill({
            propName: 'accountIds',
            pill: accountIds.map(value => ({value})),
        }));
    }, [accountIds, dispatch]);

    return (
        <Group>
            <span title={accountIds.length > MAX_SELECTED_ACCOUNTS
                ? `Max count of accounts for filtering is ${MAX_SELECTED_ACCOUNTS}`
                : undefined}>
                <FlatButton onClick={onAddToCriteria} disabled={accountIds.length > MAX_SELECTED_ACCOUNTS}>
                    <b>Filter by Selected</b>
                </FlatButton>
            </span>
            {props.showAddToAccountTeam ? (
                <FlatButton onClick={props.openAddToAccountTeamTool}>
                    <b>Add To Account Team</b>
                </FlatButton>
            ) : null}
            {props.showSetAccountStatus ? (
                <FlatButton onClick={props.openSetAccountStatusTool}>
                    <b>Set Account Status</b>
                </FlatButton>
            ) : null}
            {props.showUpdateLicense ? (
                <DropdownMenu
                    anchor={({positionRef, getAnchorProps, anchorRef}) => (
                        <FlatButton
                            endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                            {...getAnchorProps()}
                            ref={anchorRef}>
                            <b>Update License</b>
                        </FlatButton>
                    )}>
                    <DropdownMenuItem
                        caption="Enable Module Access Permissions"
                        onClick={props.openEnableModuleAccessPermissionsTool}
                    />
                    <DropdownMenuItem
                        caption="Disable Module Access Permissions"
                        onClick={props.openDisableModuleAccessPermissionsTool}
                    />
                </DropdownMenu>
            ) : null}
        </Group>
    );
};
